import styles from './index.module.scss';

interface JsonBlockProps {
  title: string;
  data?: Record<string, unknown> | null;
  compareWith?: Record<string, unknown> | null;
}

function isObject(value: unknown): value is Record<string, unknown> {
  return (
    typeof value === 'object'
    && value !== null
    && !Array.isArray(value)
  );
}

function renderValue(
  value: unknown,
  compareValue: unknown,
  level = 0,
): React.ReactNode {
  // ARRAY formatter
  if (Array.isArray(value)) {
    return (
      <div className={styles.arrayBlock}>
        [

        <div className={styles.objectInner}>
          {value.map((item, index) => {
            const compareItem = Array.isArray(compareValue)
              ? compareValue[index]
              : undefined;

            return (
              // eslint-disable-next-line react/no-array-index-key
              <div key={index}>
                {renderValue(item, compareItem)}

                {index !== value.length - 1 && ','}
              </div>
            );
          })}
        </div>

        ]
      </div>
    );
  }

  // OBJECT
  if (isObject(value)) {
    return (
      <div className={styles.objectBlock}>
        {'{'}
        <div className={styles.objectInner}>
          {Object.entries(value).map(([key, val]) => {
            const compareVal = isObject(compareValue)
              ? compareValue[key]
              : undefined;

            const changed = JSON.stringify(val)
              !== JSON.stringify(compareVal);

            return (
              <div
                key={key}
                className={changed ? styles.changed : ''}
              >
                <span className={styles.key}>
                  &quot;
                  {key}
                  &quot;:
                </span>
                {' '}
                {renderValue(val, compareVal, level + 1)}
              </div>
            );
          })}
        </div>
        {'}'}
      </div>
    );
  }

  return (
    <span>
      {JSON.stringify(value)}
    </span>
  );
}

export default function JsonBlock({
  title,
  data,
  compareWith,
}: JsonBlockProps) {
  if (!data) return null;

  return (
    <div className={styles.jsonBlock}>
      <div className={styles.title}>
        {title}
      </div>

      <pre className={styles.jsonContent}>
        {renderValue(data, compareWith)}
      </pre>
    </div>
  );
}
